import useFeatureFlags, { FeatureFlags } from './useFeatureFlags';

export default function useHasGlobalStateViewer(): boolean {
    const { hasFeature } = useFeatureFlags();
    return (
        hasFeature(FeatureFlags.HAS_GLOBAL_STATE_VIEWER_TOGGLE_BUTTON) ||
        process.env.NODE_ENV === 'development'
    );
}
